import { render, staticRenderFns } from "./DiscoverBookCard.vue?vue&type=template&id=17b2e0b8&"
import script from "./DiscoverBookCard.vue?vue&type=script&lang=js&"
export * from "./DiscoverBookCard.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverBookCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports